import Echo from "laravel-echo";
import Pusher from 'pusher-js';

$(document).ready(function() {

    require('../laroute.js');

     if (window.broadcast_driver === 'pusher') {
        window.Pusher = Pusher;

        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: window.pusher_key,
            cluster: window.pusher_cluster,
            wsHost: window.pusher_host ? window.pusher_host : `ws-${window.pusher_cluster}.pusher.com`,
            wsPort: window.pusher_port ? window.pusher_port : 80,
            wssPort: window.pusher_port ? window.pusher_port : 443,
            forceTLS: (window.pusher_scheme ? window.pusher_scheme : 'https') === 'https',
            enabledTransports: ['ws', 'wss'],
        });
    }

    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN' : $('meta[name="csrf-token"]').attr('content') } });

    var page_id = $("body").data('page-id');

    switch (page_id){
        case 'certificates_list':
            require('./public/pages/certificates_list.js');
            break;

        case 'promosets_list':
            require('./public/pages/promosets_list.js');
            break;

        case 'authorisations_list':
            require('./public/pages/thumbnail_enlarging.js');
            require('./public/pages/authorisations_list.js');
            break;

        case 'singles_list':
            require('./public/pages/thumbnail_enlarging.js');
            require('./public/pages/singles_list.js');
            require('./public/pages/search.js');
            break;

        case 'propositions':
            require('./public/pages/propositions.js');
            require('./public/pages/thumbnail_enlarging.js');
            require('./public/pages/tracklists.js');
            break;

        case 'tracklists':
            require('./public/pages/thumbnail_enlarging.js');
            require('./public/pages/tracklists.js');
            break;

        case 'tracks_list':
            require('./public/pages/thumbnail_enlarging.js');
            require('./public/pages/tracks_list.js');
            require('./public/pages/search.js');
            break;

        case 'cart':
            require('./public/pages/thumbnail_enlarging.js');
            require('./public/pages/cart.js');
            break;

        case 'settings':
            require('./public/pages/settings.js');
            break;

        case 'recharge_account_form':
            require('./public/pages/recharge_account_form.js');
            break;

        case 'use_a_code':
            require('./public/pages/use_a_code.js');
            break;
    }

    require('./public/feedback_button.js');
    require('./public/notifications.js');
    require('./common/laravel.js');


    window.add_to_cart = require('./public/functions/add_to_cart.js');
});
